import { FC } from 'react';
import { Modal } from 'antd';
import AddCategory from './addCategory';
import CategoryList from './categoryList';
import React from 'react';
import { useDispatch } from 'react-redux';
import { loadCategory } from './categorySlice';
import { CommonContext, CommonContextType } from '../../contexts/CommonContext';
import { loadProductTypes } from '../ProductType/ProductTypeSlice';
import { loadBodySizes } from '../bodySize/bodySizeSlice';

const CategoryPage: FC = () => {
  const dispatch = useDispatch();
  const { isModalOpen, setModelChange, contextHolder, editCategory, setEditCategory } = React.useContext(CommonContext) as CommonContextType;

  const showModal = () => {
    setModelChange(true);
  };
  const handleCancel = () => {
    setEditCategory(null)
    setModelChange(false);
  };


  React.useEffect(() => {
    dispatch(loadCategory());
    // dispatch(loadProductTypes());
    // dispatch(loadBodySizes());
  }, [dispatch]);

  return ( 
    <div className='padding'>
      {contextHolder}
      <h2>Category List
        <button className='top-button' onClick={showModal}>Create</button>
      </h2>
      <br></br>
      <CategoryList />
      <Modal title={editCategory?.id ? 'Edit Category' : 'Create Category'} open={isModalOpen} onCancel={handleCancel} maskClosable={false} footer={null}>
        <AddCategory />
      </Modal>
    </div>
  );
};

export default CategoryPage;